// theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  
  palette: {
    primary: {
      main: '#011a38', // blue
      contrastText: '#f5f5f5',
    },
    secondary: {
      main: '#dc004e', // pink
    },
  },
  typography: {
    fontFamily: [
      '-apple-system', 
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'Noto Sans',
      'Liberation Sans',
      'sans-serif', 
      'Apple Color Emoji', 
      'Segoe UI Emoji',
      'Segoe UI Symbol',
      'Noto Color Emoji'
    ].join(','),
    h1: {
      fontSize: '2rem',
      fontWeight: 700,
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            // borderLeft: '4px solid #bbdefb', // indicator
            backgroundColor: '#2b8ae1',      // optional subtle highlight
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#2b8ae1',
          },
          '&:hover': {
            backgroundColor: '#64b5f6',
          },
        },
      },
    },
  },
});

export default theme;